export default __webpack_public_path__ + "static/media/video-vertical-background-0001.4614575b.png";